module.exports = __webpack_public_path__ + "static/media/1_A1_03.1ee307e3.png";